import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toastifyType } from '../../constants';
import { Toaster, toast } from 'sonner'

const ToastHandler = () => {
  const dispatch = useDispatch();
  const { toastType, toastMessage } = useSelector(state => state.toast);
   
  useEffect(() => {
    if (toastType) {
      if (toastType === toastifyType.SHOW_SUCCESS_MESSAGE) {
        toast.success(toastMessage || 'Done.')
      } else if (toastType === toastifyType.SHOW_ERROR_MESSAGE) {
        // Callers pass error?.response?.data?.message, which is undefined for
        // network failures, timeouts and non-JSON error bodies. Without a
        // fallback the action fails with no feedback at all.
        toast.error(toastMessage || 'Something went wrong. Please check your connection and try again.')
      }

      // Clear toast
      dispatch({ type: toastifyType.SHOW_TOAST, payload: { type: null, message: '' } });
    }
  }, [toastType, toastMessage, dispatch]);

  return <Toaster toastOptions={{
    classNames: {
      closeButton: `!right-[-12px] left-auto rounded-md border-2 !shadow-md `,
      toast: "bg-white border-2 border-gray-200 text-[12px] tracking-wide shadow-md px-3 py-4",
    }
  }} closeButton position="bottom-right" richColors className='p-4' />;
};

export default ToastHandler;
